const Title = () => (
  <div className="pt-28 pb-16 px-4 md:pb-16 md:pt-24 md:px-16 xl:pb-24 bg-light-pink">
    <div className="flex flex-col xl:flex-row">
      <div className="w-full xl:w-3/12">
        <div>
          <h5 className="text-xs text-black font-light mt-6 md:mt-12 xl:mt-16 mb-2">
            <span className="font-josefin">PROJECT TYPE</span>
          </h5>
          <span className="text-sm xl:text-base font-jomolhari font-normal">
            Mobile App and PWA Development
          </span>
        </div>
      </div>
      <div className="w-full xl:w-3/12">
        <div className="xl:pl-16">
          <h5 className="text-xs text-black font-light mt-6 md:mt-12 xl:mt-16 mb-2">
            <span className="font-josefin">CLIENT</span>
          </h5>
          <span className="text-sm xl:text-base font-jomolhari font-normal">
            Linx & Go, England
          </span>
        </div>
      </div>
      <div className="w-full xl:w-3/12">
        <div className="xl:pl-12">
          <h5 className="text-xs text-black font-light mt-6 md:mt-12 xl:mt-16 mb-2">
            <span className="font-josefin">INDUSTRY</span>
          </h5>
          <span className="text-sm xl:text-base font-jomolhari font-normal">
            Social Networking
          </span>
        </div>
      </div>
      <div className="w-full xl:w-3/12">
        <div>
          <h5 className="text-xs text-black font-light mt-6 md:mt-12 xl:mt-16 mb-2">
            <span className="font-josefin">TECHNOLOGY USED</span>
          </h5>
          <span className="text-sm xl:text-base font-jomolhari font-normal">
            React, Node, Kotlin, Objective C
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default Title;
